(function() {
	'use strict';

	angular
		.module('app.leanProjects')
		.factory('kanbanDragService', kanbanDragService);

	function kanbanDragService() {
		var service = {
			dragged: null,
			set: set,
			get: get,
			clear: clear
		};
		return service;

		function set(project) {
			service.dragged = project;
		}

		function get() {
			return service.dragged;
		}

		function clear() {
			service.dragged = null;
		}
	}
})();
